import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor() {
    // In pdfmake < 0.2.8, vfs is exported as default.
    pdfMake.vfs = (pdfFonts as any).vfs;
  }

  open(docDefinition: any): void {
    pdfMake.createPdf(docDefinition).open();
  }

  download(docDefinition: any, fileName = 'document.pdf'): void {
    pdfMake.createPdf(docDefinition).download(fileName);
  }

  print(docDefinition: any): void {
    pdfMake.createPdf(docDefinition).print();
  }

  getBlob(docDefinition: any): Promise<Blob> {
    return new Promise((resolve) => {
      pdfMake.createPdf(docDefinition).getBlob((blob) => resolve(blob));
    });
  }

  getBase64(docDefinition: any): Promise<string> {
    return new Promise((resolve) => {
      pdfMake.createPdf(docDefinition).getBase64((data) => resolve(data));
    });
  }

  getDataUrl(docDefinition: any): Promise<string> {
    return new Promise((resolve) => {
      pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => resolve(dataUrl));
    });
  }
}
